<template>
    <div>
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Payment Links</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="newLink">New Payment Link</button>
            </div>
        </div>

        <div class="flex flex-col mt-12" v-if="links.length > 0">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Product
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Discount
                                </th>
                                <th scope="col" class="relative px-6 py-3">
                                    <span class="sr-only">Edit</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="link in links" :key="link.id">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <span>{{ link.product.product.name }}</span>
                                    </div>
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900" v-if="link.discount">
                                        <span>{{ link.discount.name }} <span class="text-gray-400">(#{{ link.discount.id }})</span></span>
                                    </div>
                                    <div class="text-sm font-medium text-gray-400" v-else>
                                        <span>-- No Discount --</span>
                                    </div>
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <a href="#" class="text-indigo-600 hover:text-indigo-900">
                                        <router-link :to="{ name: 'payment.links.view', params: { link: link.id }}">
                                            <EyeIcon class="h-5 w-5 text-gray-400 hover:text-gray-600"/>
                                        </router-link>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="4">
                                    <nav
                                        class="w-full bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
                                        aria-label="Pagination">
                                        <div class="hidden sm:block">
                                            <p class="text-sm text-gray-700">
                                                Showing records
                                                {{ ' ' }}
                                                <span class="font-medium">1</span>
                                                {{ ' ' }}
                                                to
                                                {{ ' ' }}
                                                <span class="font-medium">{{ total }}</span>
                                            </p>
                                        </div>
                                        <div class="flex-1 flex justify-between sm:justify-end">
                                            <a v-if="seeMoreButton" @click.prevent="getLinks" href="#"
                                               class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">More</a>
                                        </div>
                                    </nav>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <router-view v-slot="{ Component }">
            <component :is="Component"></component>
        </router-view>
    </div>
</template>

<script>

import {EyeIcon, ArrowPathIcon} from "@heroicons/vue/24/outline"
import {onMounted, ref} from "vue"
import {onBeforeRouteUpdate, useRoute, useRouter} from "vue-router"

export default {
    components: {
        ArrowPathIcon,
        EyeIcon,
    },
    setup() {
        const router = useRouter()
        const vueRoute = useRoute()
        const links = ref([])
        const seeMoreButton = ref(false)
        const nextUrl = ref(null)
        const total = ref(0)

        const newLink = () => {
            router.push({ name: 'payment.links.new' })
        }

        const getLinks = async (withConcat = true) => {
            if (!nextUrl.value) {
                nextUrl.value = route('transactions.links')
            }

            await axios.get(nextUrl.value)
                .then((response) => {
                    if (withConcat) {
                        links.value = links.value.concat(response.data.data)
                    } else {
                        links.value = response.data.data
                    }
                    seeMoreButton.value = response.data?.has_more
                    nextUrl.value = response.data?.next_page_url
                    total.value = total.value + links.value.length
                })
        }

        onMounted(() => {
            getLinks()
        })

        onBeforeRouteUpdate((to, from) => {
            if (to.name === 'payment.links') {
                nextUrl.value = route('transactions.links')
                getLinks(false)
            }
        })

        return {
            links,
            getLinks,
            seeMoreButton,
            total,
            newLink,
        }
    },
}
</script>
